module.exports = __webpack_public_path__ + "img/logo-UMC-tmp.885ca05f.svg";